export default __webpack_public_path__ + "static/media/inbank-logo__white.c9ca2f66.svg";